import { Flex, Skeleton } from '@chakra-ui/react'

export const MultiSelectListSkeleton = () => (
  <>
    <Flex mb='20px'>
      <Skeleton h='20px' mr='10px' w='20px' />
      <Skeleton h='20px' w='100%' />
    </Flex>
    <Flex mb='20px'>
      <Skeleton h='20px' mr='10px' w='20px' />
      <Skeleton h='20px' w='100%' />
    </Flex>
    <Flex mb='20px'>
      <Skeleton h='20px' mr='10px' w='20px' />
      <Skeleton h='20px' w='100%' />
    </Flex>
  </>
)
